function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StepHeader from '../step-header';
import StepWrapper from './step-wrapper';
import TonePlayer from './tone-step/tone-player';
import globals from '../../utils/globals';
var trackEnvironmentIntro = true;

var EnvironmentStep = /*#__PURE__*/function (_Component) {
  _inherits(EnvironmentStep, _Component);

  var _super = _createSuper(EnvironmentStep);

  function EnvironmentStep(props) {
    var _this;

    _classCallCheck(this, EnvironmentStep);

    _this = _super.call(this, props);
    _this.state = {
      currentView: EnvironmentStep.INTRO
    };
    _this.gotoView = _this.gotoView.bind(_assertThisInitialized(_this));

    if (trackEnvironmentIntro) {
      window.DGS.Event.getInstance().trigger('trackHearingTestNextStep', globals.STEP_TYPE_ENVIRONMENT_INTRO, props.content.Id);
      trackEnvironmentIntro = false;
    }

    return _this;
  }

  _createClass(EnvironmentStep, [{
    key: "gotoView",
    value: function gotoView(view) {
      window.DGS.Event.getInstance().trigger('trackHearingTestNextStep', globals.STEP_TYPE_ENVIRONMENT, this.props.content.Id);
      this.setState({
        currentView: view
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          content = _this$props.content,
          onNextClick = _this$props.onNextClick,
          points = _this$props.points;
      var currentView = this.state.currentView;
      return /*#__PURE__*/React.createElement(StepWrapper, {
        backgroundImage: content.BackgroundImage,
        stepClassNames: "step--environment"
      }, /*#__PURE__*/React.createElement(StepHeader, {
        icon: content.StepHeaderIcon,
        header: content.StepHeaderTitle
      }), currentView === EnvironmentStep.INTRO && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
        className: "step__title"
      }, content.Heading), /*#__PURE__*/React.createElement("p", {
        className: "step__body"
      }, content.Body), /*#__PURE__*/React.createElement("button", {
        className: "step-button",
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.gotoView(EnvironmentStep.SOUND);
        }
      }, content.NextButtonLabel)), currentView === EnvironmentStep.SOUND && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TonePlayer, {
        soundFile: content.SoundFile,
        onFinishedPlaying: function onFinishedPlaying() {
          return _this2.gotoView(EnvironmentStep.QUESTION);
        },
        controlsEnabled: false
      })), currentView === EnvironmentStep.QUESTION && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
        className: "step__title"
      }, content.Question), content.ResponseOptions.map(function (responseOption, index) {
        return /*#__PURE__*/React.createElement("button", {
          className: "step-button" // eslint-disable-next-line react/no-array-index-key
          ,
          key: index,
          onClick: function onClick(e) {
            e.preventDefault();
            onNextClick({
              points: responseOption.TriggerPoints ? points : 0
            });
          }
        }, responseOption.Label);
      })));
    }
  }], [{
    key: "INTRO",
    get: function get() {
      return 'intro';
    }
  }, {
    key: "SOUND",
    get: function get() {
      return 'sound';
    }
  }, {
    key: "QUESTION",
    get: function get() {
      return 'question';
    }
  }]);

  return EnvironmentStep;
}(Component);

EnvironmentStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  onNextClick: PropTypes.func.isRequired
};
export default EnvironmentStep;